import React from 'react'
import { Trans } from 'react-i18next'
import { withTranslationCustom } from 'lib/i18next'

import Button from 'components/UI/Button'
import ErrorMessageContent from './ErrorMessageContent'

import 'styles/status-message.pcss'

const TemporaryServiceError = ({ t }) => {
    return (
        <ErrorMessageContent
            content={(
                <p>
                    <Trans i18nKey="errors:omanettix.10056.message">
                        Temporary service error.
                    </Trans>
                </p>
            )}
            actions={(
                <Button
                    trackName="refreshPage"
                    className="button"
                    onClick={() => { window.location.reload() }}
                    type="button"
                >
                    {t('common:refreshPage', 'Refresh page')}
                </Button>
            )}
        />
    )
}

export default withTranslationCustom(['errors', 'common'])(TemporaryServiceError)
